import * as z from "zod/v4";

export const bulkPickWorkOrderLines = {
  name: "bulkPickWorkOrderLines" as const,
  input: z.object({
    picks: z.array(
      z.object({
        pickLineId: z.string(),
        quantityPicked: z.number().int().nonnegative(),
      }),
    ),
    sessionId: z.string().optional(),
    // Tote assignment: assign these WOs to the tote before picking
    toteBarcode: z.string().optional(),
    toteWorkOrderIds: z.array(z.string()).optional(),
  }),
  output: z.object({
    pickedCount: z.number(),
    advancedWorkOrderIds: z.array(z.string()),
    toteStorageLocationName: z.string().nullable(),
  }),
};
